import React from "react";
import classes from "./techOverview.module.scss";
import arrowIcon from "../../assets/arrow.svg";
import { Collapse } from "react-bootstrap";

const Auth = ({ openTab, setOpenTab }) => {
  return (
    <>
      <button
        onClick={() => {
          if (openTab !== "Auth") {
            setOpenTab("Auth");
          } else setOpenTab(null);
        }}
        aria-controls="auth-collapse-text"
        aria-expanded={openTab === "Auth"}
        className={`${classes.btn} d-flex align-items-center justify-content-between pt-3 pb-2 px-0`}
      >
        Authentication <img src={arrowIcon} alt="" style={{ width: "12px" }} />
      </button>
      <Collapse in={openTab === "Auth"}>
        <div id="auth-collapse-text" className={classes.content}>
          <p>
            All requests sent to our servers must use an encrypted connection
            (HTTPS) and include the authorization header{" "}
            <span className={classes["connection-key"]}>
              "Authorization IoT &lt;connectionKey&gt;:&lt;projectName&gt;
            </span>
            .
          </p>
          <p>
            You have two connection keys, which can be found on the dashboard,
            and they should be used accordingly.
          </p>
          <p>
            The first key is the{" "}
            <span className={classes["connection-key"]}>
              TEST connection key
            </span>
            , which can be used to interact with the test environment for
            implementation purposes.
          </p>
          <p>
            The second key is the{" "}
            <span className={classes["connection-key"]}>
              PRODUCTION connection key
            </span>
            , which you obtain when you switch to one of the production plans.
            This key will allow you to interact with the production TAP
            environment.
          </p>
        </div>
      </Collapse>
    </>
  );
};

export default Auth;
